/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskCoordinates
 */
export interface ExecRiskCoordinates {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskCoordinates
     */
    longitude: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskCoordinates
     */
    latitude: number;
}

/**
 * Check if a given object implements the ExecRiskCoordinates interface.
 */
export function instanceOfExecRiskCoordinates(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "longitude" in value;
    isInstance = isInstance && "latitude" in value;

    return isInstance;
}

export function ExecRiskCoordinatesFromJSON(json: any): ExecRiskCoordinates {
    return ExecRiskCoordinatesFromJSONTyped(json, false);
}

export function ExecRiskCoordinatesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskCoordinates {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'longitude': json['longitude'],
        'latitude': json['latitude'],
    };
}

export function ExecRiskCoordinatesToJSON(value?: ExecRiskCoordinates | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'longitude': value.longitude,
        'latitude': value.latitude,
    };
}

